import { ThumbsUpButton } from 'components/core/thumbs-rating-buttons'
export default ThumbsUpButton
